import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Tag, Popover} from 'antd'
import { QuestionCircleFilled, EditOutlined, DeleteOutlined, LockOutlined, UnlockOutlined, EyeOutlined} from '@ant-design/icons'
import FormModal from './FormModal'
import ResourcePoolList from './ResourcePoolList'
import {withTranslation} from 'react-i18next'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
const storage = window.localStorage
const {confirm} = Modal

@inject('marketingResourcePoolStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    detailsModalVisible: false,
    record: null
  }

  componentDidMount() {
  }

  handleEdit = (record) => {
    const {marketingResourcePoolStore} = this.props
    marketingResourcePoolStore.onGetJobAction(record.id).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const {marketingResourcePoolStore,t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        marketingResourcePoolStore.onDeleteJobAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {marketingResourcePoolStore} = this.props
    marketingResourcePoolStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleChangeActive = (record) => {
    const {marketingResourcePoolStore} = this.props
    marketingResourcePoolStore.onChangeStatus({
      "status": record?.status===0 ? 1 : record?.status===1 ? 0 : null,
      "id": record?.id,
    })
  }

  handleDetails = (record) => {
    this.setState({
      detailsModalVisible: true,
      record: record
    })
  }
  
  handleCancelResourcePool = () => {
    const {marketingResourcePoolStore} = this.props
    this.setState({
      detailsModalVisible: false
    })
    marketingResourcePoolStore.onClearSelectedRowKeys([],[])
    marketingResourcePoolStore.onChangeIsAll(false)
  }
  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {marketingResourcePoolStore, accountStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList, groupList, statusList} = marketingResourcePoolStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const isPowerUser = accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser || false
    const TagsList = (tags, list, val1, val2) => {
      const maxCount = 2; // 最多显示的 Tag 数量
      const remainingCount = tags?.length - maxCount; // 剩余的 Tag 数量
    
      // 如果 Tag 数量超过 maxCount，则截取前 maxCount 个，剩余的用 Tooltip 显示
      const visibleTags = tags?.slice(0, maxCount);
      const content = tags?.map((tag, index) => (
        <Tag color="blue" key={index}>{list?.find(a=>a[val1]===tag) ? list?.find(a=>a[val1]===tag)[val2] : null}</Tag>
      ))
      return (
        <div>
          {/* 显示可见的 Tag */}
          {visibleTags?.map((tag, index) => (
            <Tag color="blue" key={index}>{list?.find(a=>a[val1]===tag) ? list?.find(a=>a[val1]===tag)[val2] : null}</Tag>
          ))}
    
          {/* 如果有多余的 Tag，显示剩余数量，并用 Tooltip 展示所有隐藏的 Tag */}
          {remainingCount > 0 && (
          <Popover content={content}>
              <Tag color="blue">+{remainingCount}</Tag>
          </Popover>
          )}
        </div>
      );
    };
    const TagsList2 = (tags) => {
      const maxCount = 2; // 最多显示的 Tag 数量
      const remainingCount = tags?.length - maxCount; // 剩余的 Tag 数量
    
      // 如果 Tag 数量超过 maxCount，则截取前 maxCount 个，剩余的用 Tooltip 显示
      const visibleTags = tags?.slice(0, maxCount);
      const content = tags?.map((tag, index) => (
        <Tag color="blue" key={index}>{tag}</Tag>
      ))
      return (
        <div>
          {/* 显示可见的 Tag */}
          {visibleTags?.map((tag, index) => (
            <Tag color="blue" key={index}>{tag}</Tag>
          ))}
    
          {/* 如果有多余的 Tag，显示剩余数量，并用 Tooltip 展示所有隐藏的 Tag */}
          {remainingCount > 0 && (
          <Popover content={content}>
              <Tag color="blue">+{remainingCount}</Tag>
          </Popover>
          )}
        </div>
      );
    };
    return (
      <>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} bordered>
          <Table.Column align="center" width={80} fixed="left" title={t(`marketingManagement.status`)} dataIndex="status" key="status"
            render={text => <div style={{
              display: 'inline-block',
              height: 24,
              width: 24,
              lineHeight: '24px',
              fontSize: 12,
              borderRadius: 24,
              color: 'white',
              textAlign: 'center',
              background: text===0 ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e'
            }} title={text===0 ? '启用' : '停用'}>{text===0 ? '启' : '停'}</div>}
          />
          <Table.Column title={t(`marketingManagement.marketingGroup`)} dataIndex="marketingGroupNames" key="marketingGroupNames" ellipsis={true} render={(text, record) => {
            return text && text?.length > 0 ? TagsList2(text) : null
          }} />
          <Table.Column title={t(`marketingManagement.resourcePoolName`)} dataIndex="resourcePoolName" key="resourcePoolName" ellipsis={true} />
          <Table.Column title={t(`marketingManagement.marketingClass`)} dataIndex="marketingType" key="marketingType" ellipsis={true} render={(text, record) => {
            return text && text?.length > 0 ? TagsList(text, statusList, 'code', 'name') : null
          }} />
          {/* <Table.Column width={100} title={t(`marketingManagement.status`)} dataIndex="status" key="status" ellipsis={true} render={(text, record) => 
            statusList?.find(a=>parseInt(a?.code)===text)?.name
          } /> */}
          <Table.Column width={450} align="center" fixed="right" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              {isPowerUser ? <>
                <Button type="" onClick={() => this.handleEdit(record)} shape='round' style={{marginRight: 10}} icon={<EditOutlined/>}
                        title={t(`general.edit`)}>{t(`general.edit`)}</Button>
                <Button type="" onClick={() => this.handleChangeActive(record)} shape='round' style={{marginRight: 10}}
                        icon={record.status === 0 ? <UnlockOutlined/> : <LockOutlined/>}
                        title={record.status === 0 ? t(`reportManagement.enabled`) : t(`reportManagement.disabled`)}>{record.status === 0 ? t(`reportManagement.enabled`) : t(`reportManagement.disabled`)}</Button>
              </> : null}
              <Button type="primary" onClick={() => this.handleDetails(record)} shape='round' style={{marginRight: 10}} icon={<EyeOutlined/>}
                      title={t(`general.details`)}>{t(`general.details`)}</Button>
              {isPowerUser ? <Button type="danger" onClick={() => this.handleDel(record)} shape='round' icon={<DeleteOutlined/>}
                                     title={t(`general.delete`)}>{t(`general.delete`)}</Button> : null}
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
        /> : null}
        {this.state.detailsModalVisible ? 
          <ResourcePoolList handleCancel={this.handleCancelResourcePool} addModalVisible={this.state.detailsModalVisible} record={this.state.record} isSelect={false} /> 
        : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
